import { AnimationClassNames, PrimaryButton, Stack } from '@fluentui/react';
import { useReactFlow } from '@xyflow/react';
import clsx from 'clsx';
import { DRAWER_CLOSE_WIDTH } from 'common/constants';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ApprovalsInfo } from '../__generated__/ApprovalsInfo';
import { Body } from './Body';
import { useStyles } from './index.styles';

export const ApprovalFlowDesigner: React.FC<{
  approvalId: string | undefined;
  approvalsInfo: ApprovalsInfo | undefined;
  currentApprovalTypeFilter: number;
  setApprovalType: React.Dispatch<React.SetStateAction<number | undefined>>;
}> = ({ approvalId, ...rest }) => {
  const { setNodes, setEdges } = useReactFlow();

  const [visibility, setVisibility] = useState<boolean>(false);
  const styles = useStyles();
  const history = useHistory();
  useEffect(() => {
    if (approvalId !== undefined) {
      setVisibility(true);
    } else {
      setVisibility(false);
    }
  }, [approvalId]);

  const isNew = !approvalId?.length;

  return (
    <Stack>
      <PrimaryButton text="Add Approval" onClick={() => setVisibility(true)} />

      {visibility && (
        <Stack
          style={{
            // transition: 'all 0.3 ease',
            // width: `calc(100vw - ${
            //   expanded ? DRAWER_OPEN_WIDTH : DRAWER_CLOSE_WIDTH
            // }px)`,
            width: `calc(100vw - ${DRAWER_CLOSE_WIDTH}px)`,
          }}
          className={clsx(styles.container, AnimationClassNames.slideLeftIn40)}
        >
          <Body
            isNew={isNew}
            approvalId={approvalId}
            onClose={() => {
              
              setNodes([]);
              setEdges([]);
              history.push('/account-management/approval-setup');
              setVisibility(false);
            }}
            {...rest}
          />
        </Stack>
      )}
    </Stack>
  );
};
